import { Link } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { Ticket, Calendar, MapPin, ExternalLink, ChevronRight, Sparkles } from "lucide-react";
import { useHomeData } from "./QuickListsOptimized";

export function SpotlightSection() {
  const { data, loading } = useHomeData();

  if (loading || !data?.spotlight?.length) return null;

  return (
    <section className="px-6 md:px-12 lg:px-24 pb-12" data-testid="spotlight-section">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-2 mb-6">
          <Sparkles className="h-5 w-5 text-pink-400" />
          <h2 className="text-xl font-bold text-foreground">Jangan Miss Ni</h2>
        </div>

        <div className="grid grid-cols-1 gap-6">
          {data.spotlight.map((event) => (
            <SpotlightCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
}

function SpotlightCard({ event }) {
  const eventDate = event.date ? parseISO(event.date) : null;
  const poster = event.image_url || event.image;

  return (
    <div
      className="glass-card rounded-2xl overflow-hidden border border-pink-500/20 flex flex-col md:flex-row hover:border-pink-500/40 transition-colors"
      data-testid={`spotlight-card-${event.id}`}
    >
      {/* Poster */}
      <Link
        to={`/event/${event.id}`}
        className="relative md:w-2/5 lg:w-1/3 shrink-0 overflow-hidden bg-black/40 group"
      >
        {poster ? (
          <img
            src={poster}
            alt={event.title}
            loading="lazy"
            className="w-full h-64 md:h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-64 md:h-full flex items-center justify-center">
            <Ticket className="h-12 w-12 text-white/20" />
          </div>
        )}
        <span className="absolute top-3 left-3 text-[10px] font-bold text-white bg-pink-500 px-2.5 py-1 rounded-full uppercase tracking-wide">
          Tiket Dijual
        </span>
      </Link>

      {/* Content */}
      <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
        <Link to={`/event/${event.id}`}>
          <h3 className="text-2xl md:text-3xl font-extrabold text-foreground leading-tight mb-3 hover:text-pink-400 transition-colors">
            {event.title}
          </h3>
        </Link>

        <div className="space-y-2 mb-6">
          {eventDate && (
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Calendar className="h-4 w-4 text-pink-400 shrink-0" />
              <span>
                {format(eventDate, "d MMMM yyyy")}
                {event.time ? ` • ${event.time}` : ""}
              </span>
            </div>
          )}
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <MapPin className="h-4 w-4 text-emerald-400 shrink-0" />
            <span>{event.location}</span>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          {event.ticket_url && (
            <a
              href={event.ticket_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-xl bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold shadow-lg shadow-pink-500/30 hover:opacity-90 transition-opacity"
              data-testid={`spotlight-buy-ticket-${event.id}`}
            >
              <Ticket className="h-5 w-5" />
              Beli Tiket Sekarang
              <ExternalLink className="h-4 w-4" />
            </a>
          )}
          <Link
            to={`/event/${event.id}`}
            className="inline-flex items-center gap-1 h-12 px-4 rounded-xl border border-white/20 text-foreground font-medium hover:bg-white/5 transition-colors"
            data-testid={`spotlight-details-${event.id}`}
          >
            Lihat Details
            <ChevronRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SpotlightSection;
